export const urls = {

  sendEnquiry:'/api/enquiry/',
  enrollNow:'/api/enroll/'

};
